import {createActions} from 'client/framework';

const normalActions = ['SELECT_COLUMN'];

const twoWayQuestionActions = createActions(null, normalActions);
export default twoWayQuestionActions;
